export default {
  title: '{{company}} zaktualizowało Twój czas odbioru',
  new_time_label: 'Nowy czas',
};
